module.exports = __webpack_public_path__ + "img/nawloc.f19e60b8.webp";